module.exports = __webpack_public_path__ + "img/refresh.ef1c1f48.svg";